/**
 * WordPress dependencies
 */
import { RawHTML } from '@wordpress/element';

export default function save() {
	return <RawHTML>{ '<!--nextpage-->' }</RawHTML>;
}
